import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
import { useRouter } from 'next/router';

const Back = () => {
  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  return (
    <div onClick={() => goBack()} className={classes.back_button}>
      <img src="/icons/arrow-left.svg" alt="arrow-left"></img>
      Back to the previous page
    </div>
  );
};

export default function BackButton({ link=null, page="previous page", className }) {

  return (
    <div className={clsx(className)}>      
      {
        !link && 
        <Back/>
      }
      {
        link &&
        <a href={link}>
          <img src="/icons/arrow-left.svg" alt="arrow-left"></img>
          Back to the {page}
        </a>
      }
    </div>
  );
}

BackButton.defaultProps = {
  className: "",
};
